var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vue-root" },
    [
      !_vm.success && _vm.generalErrors !== null && _vm.generalErrors.length > 0
        ? [
            _vm._t("general-errors", function () {
              return [
                _c("div", { staticClass: "error-message" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.generalErrorMessage) +
                      "\n            "
                  ),
                ]),
              ]
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      Object.keys(_vm.formValues).length > 0
        ? _c(
            "form",
            {
              ref: "form",
              staticClass: "form webform row",
              class: [
                _vm.formClass,
                {
                  "webform--floating-labels": _vm.floatingLabels,
                  "webform--success": _vm.success,
                },
              ],
              attrs: {
                enctype: "multipart/form-data",
                method: "post",
                novalidate: "",
              },
            },
            [
              _c("input", {
                attrs: { name: "path", type: "hidden" },
                domProps: { value: _vm.path },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { name: "id", type: "hidden" },
                domProps: { value: _vm.identifier },
              }),
              _vm._v(" "),
              _vm._l(_vm.structure, function (item) {
                return _c(_vm.component(item), {
                  key: item.items[0].data.id,
                  tag: "component",
                  attrs: {
                    "btn-label": _vm.btnLabel,
                    errors: _vm.errors,
                    "form-values": _vm.formValues,
                    "general-errors": _vm.generalErrors,
                    item: item.type === "formitem" ? item.items[0] : item,
                    values: _vm.values,
                  },
                  on: {
                    submit: _vm.submit,
                    "update-form-value": _vm.updateFormValue,
                  },
                })
              }),
              _vm._v(" "),
              _vm._l(_vm.duplicateFields, function (dup, index) {
                return _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formValues[dup.source],
                      expression: "formValues[ dup.source ]",
                    },
                  ],
                  key: index,
                  attrs: {
                    id: _vm.getIdByUniqlabel(dup.target),
                    name: _vm.getIdByUniqlabel(dup.target),
                    type: "hidden",
                  },
                  domProps: { value: _vm.formValues[dup.source] },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formValues, dup.source, $event.target.value)
                    },
                  },
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }